import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@sm/wds-react';
import classNames from 'classnames';
import SMHeaderContext from '../../../SMHeaderContext';
import { NavBarAnonContext } from '../NavBarAnonContext';

export const SubMenu = ({ submenuKey, title, children }) => {
  const { lang } = useContext(SMHeaderContext);
  const { submenuOpened } = useContext(NavBarAnonContext);

  const submenuClassname = classNames(
    'sm-nav-submenu__container',
    `sm-nav-submenu__${submenuKey.toLowerCase()}`,
    'sm-utils--text-align-left',
    { 'sm-nav-submenu--en': lang === 'en' },
    { 'sm-nav-submenu--de': lang === 'de' },
    { 'sm-nav-submenu--fr': lang === 'fr' },
    { 'sm-nav-submenu--locale': lang !== 'en' },
    { 'sm-nav-submenu--open': submenuOpened === submenuKey }
  );

  return (
    <div className={submenuClassname}>
      {lang !== 'en' && (
        <Typography
          variant="sectionTitle"
          className="sm-nav-submenu__title sm-utils--text-align-center sm-utils--mw-90 sm-utils--mx-auto sm-utils--text-overflow-break"
        >
          {title}
        </Typography>
      )}
      {children}
    </div>
  );
};

export default SubMenu;

SubMenu.propTypes = {
  title: PropTypes.string.isRequired,
  submenuKey: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
